import { createApiRef } from '@backstage/core-plugin-api';
import type {
  Stack,
  FxEnvironmentsResponse,
  CloneCompanyAndWorkflowsRequest,
  CloneCompanyAndWorkflowsResponse,
  CloneCompanyWorkflow,
  CloneCompanyWorkflowDetail,
  ProdToLowerConfigView,
  ProdToLowerRequest,
  ProdToLowerRunView,
} from './types';

/**
 * Interface for the Kamino API
 * @public
 */
export interface KaminoApi {
  getAvailableStacks(): Promise<Stack[]>;
  getFxEnvironments(): Promise<FxEnvironmentsResponse>;
  requestCloneCompanyAndWorkflows(
    request: CloneCompanyAndWorkflowsRequest,
  ): Promise<CloneCompanyAndWorkflowsResponse>;
  getOperations(): Promise<CloneCompanyWorkflow[]>;
  getOperationDetail(operationId: string): Promise<CloneCompanyWorkflowDetail>;

  /** Prod-to-lower clone: what the request form offers. */
  getProdToLowerConfig(): Promise<ProdToLowerConfigView>;
  listProdToLowerRuns(): Promise<ProdToLowerRunView[]>;
  getProdToLowerRun(runId: string): Promise<ProdToLowerRunView>;
  requestProdToLowerRun(
    request: ProdToLowerRequest,
  ): Promise<ProdToLowerRunView>;
  /** Release a sealed export; warnings must be acknowledged when present. */
  releaseProdToLowerRun(
    runId: string,
    options: { acknowledgeWarnings: boolean },
  ): Promise<ProdToLowerRunView>;
  retryProdToLowerRun(runId: string): Promise<ProdToLowerRunView>;
  cancelProdToLowerRun(runId: string): Promise<ProdToLowerRunView>;
}

/**
 * API reference for the Kamino plugin
 * @public
 */
export const kaminoApiRef = createApiRef<KaminoApi>({
  id: 'plugin.kamino.api',
});
